import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressBookingsBookingsV2BookingsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    _: [
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
        destPath: '/v2/bulk/multi_service_bookings',
      },
      {
        srcPath: '/bookings/multiServiceBookings/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
        destPath:
          '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
      },
      {
        srcPath: '/bookings/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/bulk/multi_service_bookings/get_allowed_actions',
        destPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
        destPath: '/v2/bulk/multi_service_bookings',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/bookings/v2/bookings',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath: '/bookings/multiServiceBookings/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
        destPath:
          '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
      },
      {
        srcPath: '/bookings/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/bulk/multi_service_bookings/get_allowed_actions',
        destPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/bookings-service',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/bookings/multiServiceBookings/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
        destPath:
          '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
      },
      {
        srcPath: '/bookings/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/bulk/multi_service_bookings/get_allowed_actions',
        destPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    _: [
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
        destPath: '/v2/bulk/multi_service_bookings',
      },
      {
        srcPath: '/bookings/multiServiceBookings/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
        destPath:
          '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
      },
      {
        srcPath: '/bookings/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/bulk/multi_service_bookings/get_allowed_actions',
        destPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
        destPath: '/v2/bulk/multi_service_bookings',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/bookings/v2/bookings',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath: '/bookings/multiServiceBookings/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
        destPath:
          '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
      },
      {
        srcPath: '/bookings/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/bulk/multi_service_bookings/get_allowed_actions',
        destPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/bookings-service/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath: '/_api/bookings-service/v2/bookings',
        destPath: '/v2/bookings',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/bookings-service',
        destPath: '/v2/bookings',
      },
      {
        srcPath: '/bookings/multiServiceBookings/v2/multi_service_bookings',
        destPath: '/v2/multi_service_bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
        destPath:
          '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
      },
      {
        srcPath: '/bookings/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
      {
        srcPath:
          '/bookings/multiServiceBookings/v2/bulk/multi_service_bookings/get_allowed_actions',
        destPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveWixBookingsAnonymousActionsV1AnonymousBookingActionsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/v1/anonymous-bookings',
        destPath: '/v1/anonymous-bookings',
      },
      {
        srcPath: '/_api/v1/anonymous-bookings',
        destPath: '/v1/anonymous-bookings',
      },
    ],
    _: [
      {
        srcPath: '/v1/anonymous-bookings',
        destPath: '/v1/anonymous-bookings',
      },
      {
        srcPath: '/_api/anonymous-booking-actions',
        destPath: '/v1/anonymous-bookings',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/anonymous-booking-actions',
        destPath: '/v1/anonymous-bookings',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/_api/bookings-confirmator/v2/bookings/confirmation',
        destPath: '/v2/bookings/confirmation',
      },
      {
        srcPath: '/bookings/v2/confirmation',
        destPath: '/v2/confirmation',
      },
      {
        srcPath: '/bookings/v2/bulk/confirmation',
        destPath: '/v2/bulk/confirmation',
      },
      {
        srcPath: '/bookings/v2/bulk/bookings/confirmOrDecline',
        destPath: '/v2/bulk/bookings/confirmOrDecline',
      },
      {
        srcPath: '/_api/bookings-confirmator/v2/bulk/confirmation',
        destPath: '/v2/bulk/confirmation',
      },
      {
        srcPath: '/_api/bookings-confirmator/v2/bulk/bookings/confirmOrDecline',
        destPath: '/v2/bulk/bookings/confirmOrDecline',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/bookings/v2/confirmation',
        destPath: '/v2/confirmation',
      },
      {
        srcPath: '/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
    ],
    _: [
      {
        srcPath: '/bookings/v2/confirmation',
        destPath: '/v2/confirmation',
      },
      {
        srcPath: '/bookings/v2/bulk/bookings',
        destPath: '/v2/bulk/bookings',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_bookings_bookings';

/**
 * Updates the booking `status` to `CONFIRMED`, `PENDING`, or `DECLINED` based
 * on the `paymentStatus` you provide, double booking conflicts, and whether
 * the service requires business approval.
 *
 * ### eCommerce checkout restriction
 *
 * Call this method only when using a custom checkout page.
 * Don't call it when using a [Wix eCommerce checkout](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction).
 * In such cases, Wix Bookings automatically updates the booking status based on the `paymentStatus` of the corresponding [Wix eCommerce order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction).
 *
 * ### When to call Confirm Booking or Decline Booking instead
 *
 * This method has specific limitations based on payment status and double booking conflicts.
 * Use the alternative methods in these scenarios:
 * + **To force confirm double-booked free bookings:** Call [Confirm Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-booking).
 * Confirm Or Decline Booking can't confirm double-booked free bookings.
 * + **To decline bookings without double booking conflicts:** Call [Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/decline-booking).
 * Confirm Or Decline Booking only declines bookings when both a double booking conflict exists and payment status is unpaid.
 *
 * ### New booking status
 *
 * The booking `status` is set to `DECLINED` if both of the following conditions
 * are met:
 * + You provide `UNDEFINED`, `NOT_PAID`, `REFUNDED`, or `EXEMPT` as payment status.
 * + There is a double booking conflict.
 *
 * If only one or none of these conditions is met, `status` is set to `PENDING`
 * or `CONFIRMED` depending on whether the service requires business approval.
 *
 * ### Double bookings
 *
 * If there is a double booking conflict, but the booking has already been at least
 * partially paid, the method still marks the booking as `PENDING` or `CONFIRMED`.
 * Then, it also sets `doubleBooked` to `true`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences in confirmation behavior if the
 * booking was created with special `flowControlSettings`:
 * + If the booking's `flowControlSettings.skipAvailabilityValidation` was set to
 * `true`, the booking is never declined regardless of double booking conflicts.
 * Instead, it's marked `CONFIRMED` or `PENDING`, depending on whether the
 * service requires business approval.
 * + If the booking's `flowControlSettings.skipBusinessConfirmation` was set to
 * `true`, the booking skips `PENDING` status and is marked `CONFIRMED`
 * immediately.
 */
export function confirmOrDeclineBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __confirmOrDeclineBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.confirmator.v2.Confirmator.ConfirmOrDeclineBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl({
        protoPath: '/v2/confirmation/{bookingId}:confirmOrDecline',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __confirmOrDeclineBooking;
}

/**
 * Confirms or declines up to 300 bookings.
 *
 *
 * See [Confirm Or Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking)
 * for details about when a booking is confirmed or declined.
 */
export function bulkConfirmOrDeclineBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkConfirmOrDeclineBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.confirmator.v2.Confirmator.BulkConfirmOrDeclineBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl({
        protoPath: '/v2/bulk/bookings/confirmOrDecline',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.startDate' },
              { path: 'results.item.endDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'results.item.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'results.item.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkConfirmOrDeclineBooking;
}

/**
 * Cancels a booking using an anonymous token.
 *
 *
 * This method doesn't require standard authentication. Pass a token generated by [Get Anonymous Action Token](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/get-anonymous-action-token) instead.
 *
 * Before calling this method, check that `allowedAnonymousActions.cancel` is `true` in the [Get Booking Anonymously](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/anonymous-booking-actions-service-get-booking-anonymously) response.
 */
export function bookingsCancelBookingAnonymously(
  payload: object
): RequestOptionsFactory<any> {
  function __bookingsCancelBookingAnonymously({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.anonymous.actions.v1.AnonymousBookingActionsService.CancelBookingAnonymously',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsAnonymousActionsV1AnonymousBookingActionsServiceUrl(
        {
          protoPath: '/v1/anonymous-bookings/{token}/cancel',
          data: payload,
          host,
        }
      ),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bookingsCancelBookingAnonymously;
}

/**
 * Reschedules a booking to a new slot using an anonymous token.
 *
 *
 * This method doesn't require standard authentication. Pass a token generated by [Get Anonymous Action Token](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/get-anonymous-action-token) instead.
 *
 * Before calling this method, check that `allowedAnonymousActions.reschedule` is `true` in the [Get Booking Anonymously](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/anonymous-booking-actions-service-get-booking-anonymously) response.
 *
 * A notification is always sent to participants.
 */
export function bookingsRescheduleBookingAnonymously(
  payload: object
): RequestOptionsFactory<any> {
  function __bookingsRescheduleBookingAnonymously({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.anonymous.actions.v1.AnonymousBookingActionsService.RescheduleBookingAnonymously',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsAnonymousActionsV1AnonymousBookingActionsServiceUrl(
        {
          protoPath: '/v1/anonymous-bookings/{token}/reschedule',
          data: payload,
          host,
        }
      ),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bookingsRescheduleBookingAnonymously;
}

/**
 * Retrieves a booking and its allowed anonymous actions using an anonymous token.
 *
 *
 * This method doesn't require standard authentication. Pass a token generated by [Get Anonymous Action Token](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/get-anonymous-action-token) instead.
 *
 * To include booking fee details, specify `BOOKING_FEES` in `fields`.
 */
export function bookingsGetBookingAnonymously(
  payload: object
): RequestOptionsFactory<any> {
  function __bookingsGetBookingAnonymously({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'GET' as any,
      methodFqn:
        'wix.bookings.anonymous.actions.v1.AnonymousBookingActionsService.GetBookingAnonymously',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsAnonymousActionsV1AnonymousBookingActionsServiceUrl(
        { protoPath: '/v1/anonymous-bookings/{token}', data: payload, host }
      ),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bookingsGetBookingAnonymously;
}

/**
 * Retrieves the [service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/introduction) associated with a booking using an anonymous token.
 *
 *
 * This method doesn't require standard authentication. Pass a token generated by [Get Anonymous Action Token](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/get-anonymous-action-token) instead.
 */
export function getServiceAnonymously(
  payload: object
): RequestOptionsFactory<any> {
  function __getServiceAnonymously({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'GET' as any,
      methodFqn:
        'wix.bookings.anonymous.actions.v1.AnonymousBookingActionsService.GetServiceAnonymously',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsAnonymousActionsV1AnonymousBookingActionsServiceUrl(
        {
          protoPath: '/v1/anonymous-bookings/{token}/service',
          data: payload,
          host,
        }
      ),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getServiceAnonymously;
}

/**
 * Generates an anonymous action token for a booking.
 *
 * The generated token is an encrypted, URL-safe string that authorizes booking actions without authentication. Specify the token when calling other methods in this API to retrieve, cancel, or reschedule the booking without authentication.
 *
 * This is the only method in this API that requires authentication.
 */
export function getAnonymousActionToken(
  payload: object
): RequestOptionsFactory<any> {
  function __getAnonymousActionToken({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'GET' as any,
      methodFqn:
        'wix.bookings.anonymous.actions.v1.AnonymousBookingActionsService.GetAnonymousActionToken',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsAnonymousActionsV1AnonymousBookingActionsServiceUrl(
        {
          protoPath: '/v1/anonymous-bookings/{bookingId}/token',
          data: payload,
          host,
        }
      ),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getAnonymousActionToken;
}

/**
 * Creates a multi-service booking and all included single-service bookings simultaneously.
 *
 *
 * ### When to call this method
 *
 * Create sequential appointments where customers book related services together. For adding existing single-service bookings to an existing multi-service booking, call [Add Bookings to Multi Service Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/add-bookings-to-multi-service-booking) instead.
 *
 * ### Requirements and behavior
 *
 * __Package constraints__: Multi-service bookings support 2-8 appointment-based single-service bookings only (course and class bookings aren't supported). All single-service bookings must be at the same location with sequential scheduling and no gaps between appointments.
 *
 * __Timing specification__: You must provide complete `slot` details (`scheduleId`, `startDate`, `endDate`) for each single-service booking. Wix Bookings validates sequential timing but doesn't auto-calculate it.
 *
 * __Package pricing__: The total price equals the sum of individual services. To handle payment, pass each single-service booking's `bookings[].bookingId` from the response to the [eCommerce checkout](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction). Don't use `multiServiceBooking.id`, the top-level multi-service booking ID isn't supported for checkout. Wix Bookings automatically syncs the payment status from the corresponding [Wix eCommerce order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction).
 *
 * __Package notifications__: Customers receive 1 unified notification for the entire multi-service booking. Wix Bookings doesn't send notifications for the package's individual single-service bookings.
 *
 * ### Related methods
 *
 * Verify availability first with [List Multi Service Availability Time Slots](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/time-slots-v2/list-multi-service-availability-time-slots).
 *
 * See [Create Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/create-booking) for more details about constraints and effects of creating single-service bookings.
 */
export function createMultiServiceBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __createMultiServiceBooking({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'bookings.createdDate' },
          { path: 'bookings.startDate' },
          { path: 'bookings.endDate' },
          { path: 'bookings.updatedDate' },
          { path: 'bookings.canceledDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'bookings.contactDetails.fullAddress.geocode.latitude' },
          { path: 'bookings.contactDetails.fullAddress.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.CreateMultiServiceBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath: '/v2/multi_service_bookings',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'multiServiceBooking.bookings.booking.createdDate' },
              { path: 'multiServiceBooking.bookings.booking.startDate' },
              { path: 'multiServiceBooking.bookings.booking.endDate' },
              { path: 'multiServiceBooking.bookings.booking.updatedDate' },
              { path: 'multiServiceBooking.bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createMultiServiceBooking;
}

/**
 * Reschedules a multi-service booking by changing the timing for all or specific single-service bookings in the package.
 *
 *
 * This method reschedules single-service bookings within the multi-service booking while maintaining sequential order. You must specify exact new timing for each service to ensure they remain back-to-back with no gaps or overlaps.
 *
 * This method fails if it can't reschedule at least 1 single-service booking. You must provide the current revision number for each single-service booking you're rescheduling to prevent conflicting changes.
 *
 * See [Reschedule Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/reschedule-booking) for single-service booking rescheduling details.
 */
export function rescheduleMultiServiceBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __rescheduleMultiServiceBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.RescheduleMultiServiceBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath:
          '/v2/multi_service_bookings/{multiServiceBookingId}/reschedule',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'multiServiceBooking.bookings.booking.createdDate' },
              { path: 'multiServiceBooking.bookings.booking.startDate' },
              { path: 'multiServiceBooking.bookings.booking.endDate' },
              { path: 'multiServiceBooking.bookings.booking.updatedDate' },
              { path: 'multiServiceBooking.bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __rescheduleMultiServiceBooking;
}

/**
 * Checks if the business can still accommodate an existing multi-service booking and returns overall bookability status, capacity details, and policy violations.
 *
 *
 * Wix Bookings considers:
 * - The relevant services' [booking policies](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction).
 * - The availability of all required [resources](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resources-v2/introduction).
 *
 * Call this method to check if an existing multi-service booking is still valid after business configuration changes.
 * For example, staff changes, policy updates, or capacity modifications.
 *
 * For checking availability before creating new multi-service bookings, call [List Multi Service Availability Time Slots](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/time-slots-v2/list-multi-service-availability-time-slots) instead.
 */
export function getMultiServiceBookingAvailability(
  payload: object
): RequestOptionsFactory<any> {
  function __getMultiServiceBookingAvailability({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.GetMultiServiceBookingAvailability',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath:
          '/v2/multi_service_bookings/{multiServiceBookingId}/get_availability',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __getMultiServiceBookingAvailability;
}

/**
 * Cancels a multi-service booking and all its associated single-service bookings.
 *
 *
 * Cancels the entire multi-service booking, updating the status of all single-service bookings to `CANCELED`.
 * The call fails if all single-service bookings are already canceled or declined.
 *
 * See [Cancel Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/cancel-booking) for single-service booking cancellation details.
 */
export function cancelMultiServiceBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __cancelMultiServiceBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.CancelMultiServiceBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/cancel',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'multiServiceBooking.bookings.booking.createdDate' },
              { path: 'multiServiceBooking.bookings.booking.startDate' },
              { path: 'multiServiceBooking.bookings.booking.endDate' },
              { path: 'multiServiceBooking.bookings.booking.updatedDate' },
              { path: 'multiServiceBooking.bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __cancelMultiServiceBooking;
}

/**
 * Updates the status for all single-service bookings in a multi-service booking to `PENDING`.
 *
 *
 * Call this method for multi-service bookings requiring manual business approval before confirmation.
 *
 * ### Status requirements
 *
 * - __Original status__: All single-service bookings must have `CREATED` status.
 * - __Target status__: All bookings move to `PENDING` together (all-or-nothing operation).
 *
 * ### Checkout restrictions
 *
 * Only call this method if the customer paid via a custom checkout. For Wix eCommerce checkouts,
 * Wix Bookings automatically manages the bookings' statuses based on payment processing.
 *
 * ### Additional updates
 *
 * - __Payment status__: Updates if you specify a new `markAsPendingBookingsInfo.paymentStatus`.
 * - __Customer notifications__: Send messages using `participantNotification`.
 * - __Revision control__: Requires current revision numbers for all single-service bookings.
 *
 * See [Mark Booking as Pending](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/mark-booking-as-pending) for more details about marking single-service bookings as pending.
 */
export function markMultiServiceBookingAsPending(
  payload: object
): RequestOptionsFactory<any> {
  function __markMultiServiceBookingAsPending({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.MarkMultiServiceBookingAsPending',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath:
          '/v2/multi_service_bookings/{multiServiceBookingId}/mark_as_pending',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'multiServiceBooking.bookings.booking.createdDate' },
              { path: 'multiServiceBooking.bookings.booking.startDate' },
              { path: 'multiServiceBooking.bookings.booking.endDate' },
              { path: 'multiServiceBooking.bookings.booking.updatedDate' },
              { path: 'multiServiceBooking.bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __markMultiServiceBookingAsPending;
}

/**
 * Updates the status for all single-service bookings in a multi-service booking to `CONFIRMED`.
 *
 *
 * Call this method for multi-service bookings requiring manual business approval.
 *
 * ### Status requirements
 *
 * - __Original status__: All single-service bookings must have `PENDING`, `CREATED`, or `WAITING_LIST` status.
 * - __Target status__: All bookings move to `CONFIRMED` together (all-or-nothing operation).
 *
 * ### Checkout restrictions
 *
 * Only call this method if the customer paid via a custom checkout. For Wix eCommerce checkouts,
 * Wix Bookings automatically manages the bookings' statuses based on payment processing.
 *
 * ### Additional updates
 *
 * - __Payment status__: Updates if you specify a new `confirmBookingsInfo.paymentStatus`.
 * - __Customer notifications__: Send messages using `participantNotification`.
 * - __Revision control__: Requires current revision numbers for all single-service bookings.
 *
 * See [Confirm Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-booking) for more details about confirming single-service bookings.
 */
export function confirmMultiServiceBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __confirmMultiServiceBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.ConfirmMultiServiceBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/confirm',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'multiServiceBooking.bookings.booking.createdDate' },
              { path: 'multiServiceBooking.bookings.booking.startDate' },
              { path: 'multiServiceBooking.bookings.booking.endDate' },
              { path: 'multiServiceBooking.bookings.booking.updatedDate' },
              { path: 'multiServiceBooking.bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __confirmMultiServiceBooking;
}

/**
 * Updates the status for all single-service bookings in a multi-service booking to `DECLINED`.
 *
 *
 * Call this method to reject multi-service bookings that can't be accommodated or don't meet business requirements.
 *
 * ### Status requirements
 *
 * - __Original status__: All single-service bookings must have `PENDING`, `CREATED`, or `WAITING_LIST` status.
 * - __Target status__: All bookings move to `DECLINED` together (all-or-nothing operation).
 *
 * ### Checkout restrictions
 *
 * Only call this method if the customer paid via a custom checkout. For Wix eCommerce checkouts,
 * Wix Bookings automatically manages the bookings' statuses based on payment processing.
 *
 * ### Additional updates
 *
 * - __Payment status__: Updates if you specify a new `declineBookingsInfo.paymentStatus`.
 * - __Customer notifications__: Send messages using `participantNotification`.
 * - __Revision control__: Requires current revision numbers for all single-service bookings.
 *
 * Refer to [Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/decline-booking) for more details about declining single-service bookings.
 */
export function declineMultiServiceBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __declineMultiServiceBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.DeclineMultiServiceBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/decline',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'multiServiceBooking.bookings.booking.createdDate' },
              { path: 'multiServiceBooking.bookings.booking.startDate' },
              { path: 'multiServiceBooking.bookings.booking.endDate' },
              { path: 'multiServiceBooking.bookings.booking.updatedDate' },
              { path: 'multiServiceBooking.bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __declineMultiServiceBooking;
}

/**
 * Retrieves information about which actions the customer can perform for up to 50 multi-service bookings.
 *
 *
 * For each multi-service booking, the response indicates which actions are currently allowed:
 * - `cancel`: Whether the customer can cancel the multi-service booking.
 * - `reschedule`: Whether the customer can adjust the multi-service booking's timing.
 *
 * Bear the following considerations in mind when calling this method:
 *
 * __Real-time validation__: Wix Bookings calculates allowed actions based on current multi-service booking status, [booking policies](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction), and [available resources](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resources-v2/introduction) at the time of the call.
 *
 * __Permission context__: Depending on the permissions of the calling [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities), you may see different allowed actions for the same multi-service booking. For example, if the identity has permissions to read only part of the multi-service booking, the response indicates which single-service bookings the identity can read.
 *
 * __Status dependencies__: Allowed actions change as bookings progress through their lifecycle (`CREATED` → `PENDING` → `CONFIRMED`/`DECLINED` → `CANCELED`).
 * Bookings can skip `PENDING` and move directly from `CREATED` to `CONFIRMED`/`DECLINED` based on service configuration.
 */
export function bulkGetMultiServiceBookingAllowedActions(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkGetMultiServiceBookingAllowedActions({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.BulkGetMultiServiceBookingAllowedActions',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkGetMultiServiceBookingAllowedActions;
}

/**
 * Retrieves a multi-service booking and all its associated single-service bookings.
 *
 *
 * Returns the complete multi-service booking information including its ID, associated single-service bookings, and the total number of scheduled single-service bookings.
 *
 * If you call on behalf of an [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) with permissions to read only part of the multi-service booking, only the permitted single-service bookings are retrieved.
 * The returned total number includes single-service bookings for which you don't have permissions.
 *
 * See [Query Extended Bookings](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-reader-v2/query-extended-bookings) for details about retrieving individual single-service bookings and additional metadata.
 */
export function getMultiServiceBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __getMultiServiceBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.GetMultiServiceBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'multiServiceBooking.bookings.booking.createdDate' },
              { path: 'multiServiceBooking.bookings.booking.startDate' },
              { path: 'multiServiceBooking.bookings.booking.endDate' },
              { path: 'multiServiceBooking.bookings.booking.updatedDate' },
              { path: 'multiServiceBooking.bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'multiServiceBooking.bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getMultiServiceBooking;
}

/**
 * Expands an existing multi-service booking by adding existing single-service bookings to the package.
 *
 *
 * ### When to call this method
 *
 * Call this method to add 1 or more existing single-service bookings to an existing multi-service booking.
 * For creating a new multi-service booking with new single-service bookings, call [Create Multi Service Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/create-multi-service-booking) instead.
 *
 * ### Package integration
 *
 * The timing of the single-service bookings to add must be compatible with the multi-service booking's sequential schedule to ensure no gaps or overlaps between services in the updated package.
 *
 * ### Requirements and limitations
 *
 * - __Maximum capacity__: The total number of single-service bookings can't exceed 8.
 * - __Booking eligibility__: You can add only independent single-service bookings that aren't part of another multi-service booking.
 * - __Status compatibility__: Added bookings must have compatible status with the target multi-service booking.
 * - __Revision control__: You must provide current revision numbers for all single-service bookings to add.
 */
export function addBookingsToMultiServiceBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __addBookingsToMultiServiceBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.AddBookingsToMultiServiceBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath:
          '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'bookings.booking.createdDate' },
              { path: 'bookings.booking.startDate' },
              { path: 'bookings.booking.endDate' },
              { path: 'bookings.booking.updatedDate' },
              { path: 'bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __addBookingsToMultiServiceBooking;
}

/**
 * Removes single-service bookings from a multi-service booking and converts them to independent single-service bookings.
 *
 *
 * ### Removal options
 *
 * __Remove all permitted bookings__: If you specify an empty `bookings` array, all single-service bookings for which the call's [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) has read permissions are removed from the multi-service booking.
 *
 * __Selective removal__: Specify single-service booking IDs and revisions to remove only specific single-service bookings from the package.
 *
 * __Sequential scheduling__: To maintain sequential scheduling, remove only first or last single-service bookings. For middle bookings, first reschedule all relevant single-service bookings to eliminate gaps. To do so, call [Reschedule Multi Service Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/reschedule-multi-service-booking) before removing the unwanted bookings.
 *
 * ### Removal behavior
 *
 * __Independent bookings__: Removed single-service bookings become independent bookings.
 * You can manage them using single-service booking methods.
 *
 * __Automatic cleanup__: Multi-service bookings must contain at least 2 services.
 * If removal results in only 1 remaining single-service booking for the multi-service booking, the entire multi-service booking is deleted and the remaining single-service booking becomes a standalone booking.
 *
 * __Revision control__: Specify current revision numbers to prevent conflicting modifications during the removal process.
 */
export function removeBookingsFromMultiServiceBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __removeBookingsFromMultiServiceBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.MultiServiceBookings.RemoveBookingsFromMultiServiceBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
        protoPath:
          '/v2/multi_service_bookings/remove_bookings_from_multi_service_booking',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'bookings.booking.createdDate' },
              { path: 'bookings.booking.startDate' },
              { path: 'bookings.booking.endDate' },
              { path: 'bookings.booking.updatedDate' },
              { path: 'bookings.booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'bookings.booking.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'bookings.booking.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __removeBookingsFromMultiServiceBooking;
}

/**
 * Creates a booking.
 *
 *
 * ### Appointment booking
 *
 * For appointment-based services, specify the relevant time slot in `bookedEntity.slot`.
 *
 * We recommend following the [appointment booking sample flow](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/sample-flows#book-an-appointment) using Time Slots V2.
 * Specify the slot's `startDate`, `endDate`, `resource`, and `location` in `booking.bookedEntity.slot`.
 *
 * ### Class session booking
 *
 * For class services, specify the relevant event ID as `bookedEntity.slot.eventId`.
 *
 * We recommend following the [class session booking sample flow](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/sample-flows#book-a-class-session) using Time Slots V2.
 * Specify the `eventId` from the selected time slot in `booking.bookedEntity.slot.eventId`.
 *
 * When you specify `eventId`, Wix Bookings automatically derives `startDate`, `endDate`, `timezone`, `resource`, and `location` based on the event details. Manually specified values are ignored.
 *
 * ### Course booking
 *
 * For course services, specify the course's schedule ID in `bookedEntity.schedule.scheduleId`.
 * We recommend following [this sample flow](https://dev.wix.com/docs/rest/business-solutions/bookings/end-to-end-booking-flows#book-a-course)
 * to minimize failed calls due to unavailability.
 *
 * ### Booking status
 *
 * Create Booking defaults to `status=CREATED`. Such bookings aren't visible in the [Booking Calendar](https://support.wix.com/en/article/wix-bookings-about-the-wix-booking-calendar).
 *
 * Only [identities](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) with `Manage Bookings` permissions can set `status=CONFIRMED`.
 *
 * ### Related resources
 *
 * Specifying a `resource` triggers an availability check, and the Create Booking call fails if the resource is unavailable.
 *
 * If you omit `resource`, resource assignment and availability validation occur during booking confirmation.
 * If no resources are available, the behavior depends on the confirmation method used and payment status.
 *
 * ### Booking form data
 *
 * When customers sign up for a service, they must fill out the [booking form](https://support.wix.com/en/article/wix-bookings-creating-and-setting-up-your-booking-forms).
 * To create a booking with a completed booking form, specify the relevant data in `formSubmission`.
 * When specifying `formSubmission`, Wix Bookings sets all `booking.contactDetails` fields based on `formSubmission` and ignores any values in `booking.contactDetails`, except for `booking.contactDetails.contactId`.
 * To avoid conflicts, send `booking.contactDetails.contactId` together with `formSubmission`, and omit other contact details.
 * Learn more about the [Bookings and Wix Forms integration](https://dev.wix.com/docs/rest/business-solutions/bookings/wix-forms-integration).
 *
 * ### Participant information
 *
 * You must specify either `participantsChoices` or `totalParticipants`.
 * The call fails if the specified `participantsChoices` aren't among the supported
 * [service options and variants](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction).
 *
 * ### Add-ons
 *
 * You can include [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) when creating a booking by specifying `bookedAddOns`.
 * Each selected add-on must belong to an [add-on group](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-add-on-groups) associated with the service and respect the group's selection limits.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer that's send
 * immediately. Ensure `participantNotification.notifyParticipants` is set to `true`
 * to send the message.
 *
 * If you specify `{"sendSmsReminder": true}`, the customer receives an SMS 24 hours
 * before the session starts. The phone number is taken from `contactDetails.phone`.
 *
 * ### Payment options
 *
 * The specified `selectedPaymentOption` indicates how the customer intends to pay, allowing for later changes to a different method supported by the service.
 *
 * When the customer pays with a [Wix eCommerce checkout](https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/purchase-flow/checkout/introduction), you must specify a `selectedPaymentOption`.
 * Otherwise, the Create Booking call fails.
 * For custom checkouts, you don't have to specify a `selectedPaymentOption`.
 *
 * ### Payment status
 *
 * All bookings are created with `paymentStatus=UNDEFINED`, ignoring the payment status you specify.
 *
 * For customers paying with a [Wix eCommerce checkout](https://dev.wix.com/docs/rest/business-solutions/e-commerce/purchase-flow/checkout/checkout/introduction), Wix Bookings automatically syncs the booking's payment status from the corresponding [eCommerce order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction).
 *
 * For customers using a custom checkout, call [Confirm or Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking) to update booking's payment status manually.
 *
 * ### Admin overwrites
 *
 * There are small but important differences when you specify special
 * `flowControlSettings`:
 *
 * - `{"skipAvailabilityValidation": true}`: The call succeeds
 * regardless of availability. If you don't specify any resource, the call
 * succeeds even if no resource of the relevant type is available.
 * - `{"skipBusinessConfirmation": true}`: Automatically confirms `PENDING`
 * bookings that require manual confirmation.
 * - `{"skipSelectedPaymentOptionValidation": true}`: Allows customers to pay
 * with payment methods that aren't supported for the service.
 * - `{"skipAddOnValidation": true}`: Allows customers to choose add-ons that aren't associated with the service or exceed group selection limits.
 * - `{"allowAddOnChanges": true}`: Allows customers to update the list of add-ons associated with the booking when rescheduling.
 *
 * When using special `flowControlSettings`, ensure you have sufficient
 * permissions. If you encounter failed calls due to insufficient permissions,
 * consider the following options:
 *
 * - **App developers** can use a higher
 * [permission](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions),
 * such as `MANAGE BOOKINGS - ALL PERMISSIONS`.
 * - **Site developers** can utilize
 * [elevation](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/authorization/elevation).
 *
 * Granting additional permissions and using elevation permits method calls that
 * would typically fail due to authorization checks. Therefore, you should use
 * them intentionally and securely.
 */
export function createBooking(payload: object): RequestOptionsFactory<any> {
  function __createBooking({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'booking.createdDate' },
          { path: 'booking.startDate' },
          { path: 'booking.endDate' },
          { path: 'booking.updatedDate' },
          { path: 'booking.canceledDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
          { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CreateBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createBooking;
}

/**
 * Creates up to 8 bookings.
 *
 *
 * See [Create Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/create-booking)
 * for more information.
 *
 * If any of the specified bookings is missing a required field the entire call
 * fails.
 *
 * If you specify 1 or more unavailable bookings, the call succeeds
 * while the unavailable bookings aren't created. Instead, they're counted as
 * failures in the returned `bulkActionMetadata`.
 */
export function bulkCreateBooking(payload: object): RequestOptionsFactory<any> {
  function __bulkCreateBooking({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'createBookingsInfo.booking.createdDate' },
          { path: 'createBookingsInfo.booking.startDate' },
          { path: 'createBookingsInfo.booking.endDate' },
          { path: 'createBookingsInfo.booking.updatedDate' },
          { path: 'createBookingsInfo.booking.canceledDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          {
            path: 'createBookingsInfo.booking.contactDetails.fullAddress.geocode.latitude',
          },
          {
            path: 'createBookingsInfo.booking.contactDetails.fullAddress.geocode.longitude',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkCreateBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bulk/bookings/create',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.startDate' },
              { path: 'results.item.endDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'results.item.contactDetails.fullAddress.geocode.latitude',
              },
              {
                path: 'results.item.contactDetails.fullAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkCreateBooking;
}

/**
 * Reschedules an appointment booking to a different slot or a class booking to
 * a different session.
 *
 *
 * ### Updating add-ons
 *
 * You can also call this method to update the list of [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) associated with the booking.
 * To do so, both of these conditions must be met:
 * + The booking must have been created with `flowControlSettings.allowAddOnChanges` set to `true`.
 * + You must have `BOOKINGS.MANAGE_ADDONS` permissions and specify `flowControlSettings.allowAddOnChanges` as `true`.
 *
 * ### Course booking limitation
 *
 * You can't reschedule course bookings.
 *
 * ### Appointment sessions
 *
 * For appointments, the old session is removed from the business calendar
 * while a new session is added. We recommend calling [Query Availability](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/availability-calendar/query-availability)
 * first and specifying the entire retrieved `slot`.
 *
 * ### Class sessions
 *
 * For classes, the new session must be an existing session belonging to the
 * same class. We recommend retrieving `availabilityEntries.slot.eventId`
 * from [Query Availability](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/availability-calendar/query-availability)
 * to avoid failed Reschedule Booking calls due to unavailability. Specify
 * only `slot.eventId` instead of the entire `slot` object.
 *
 * ### Add-ons
 *
 * You can call Reschedule Booking to replace the list of [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) associated with the booking.
 *
 * To do so, all of these conditions must be met:
 * - The booking must have been created with `flowControlSettings.allowAddOnChanges` set to `true`.
 * - You must have `BOOKINGS.MANAGE_ADDONS` permissions.
 * - For bookings paid via an [eCommerce checkout](https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/purchase-flow/checkout/introduction): The related [eCommerce order](https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/orders/draft-orders/introduction) must be in a draftable state to correctly adjust the price when modifying add-ons. You can call [Get Order Draftability Status](https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/orders/draft-orders/get-order-draftability-status), specifying the order ID to check if it's draftable. If the order isn't draftable, Reschedule Booking still succeeds, but the order's `priceSummary` isn't updated.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer. To send
 * the message, you must also specify `participantNotification.notifyParticipants`
 * as `true`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences when you specify special
 * `flowControlSettings`:
 *
 * - `{"ignoreReschedulePolicy": true}`: The call succeeds even if the
 * service's `reschedulePolicy` doesn't allow it. Also skips
 * external validation providers.
 * - `{"skipAvailabilityValidation": true}`: The call succeeds even if
 * the specified session, slot, or resource isn't available. If you don't
 * specify any resource, the call succeeds even if no resource of the relevant
 * type is available.
 * - `{"skipBusinessConfirmation": true}`: Any `PENDING` booking is
 * automatically confirmed even if the services requires the merchants's
 * manual confirmation.
 *
 * When using special `flowControlSettings`, ensure you have sufficient
 * permissions. If you encounter failed calls due to insufficient permissions,
 * consider the following options:
 *
 * - **App developers** can use a higher
 * [permission](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions),
 * such as `MANAGE BOOKINGS - ALL PERMISSIONS`.
 * - **Site developers** can utilize
 * [elevation](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/authorization/elevation).
 *
 * Granting additional permissions and using elevation permits method calls that
 * would typically fail due to authorization checks. Therefore, you should use
 * them intentionally and securely.
 */
export function rescheduleBooking(payload: object): RequestOptionsFactory<any> {
  function __rescheduleBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.RescheduleBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings/{bookingId}/reschedule',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __rescheduleBooking;
}

/**
 * Updates the booking status to `CONFIRMED` without checking whether the relevant slot or schedule is still available.
 *
 *
 * ### eCommerce checkout restriction
 *
 * Call this method only when using a custom checkout page. Don't
 * call it when using a [Wix eCommerce checkout](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction).
 * In such cases, Wix automatically updates the booking status based on
 * the `paymentStatus` of the corresponding [Wix eCommerce order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction).
 *
 * ### When to call Confirm Booking
 *
 * When using a custom checkout flow for free bookings, call this method to confirm bookings even when a double booking conflict exists.
 * The alternative [Confirm or Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking) method doesn't support confirming double-booked free bookings in this scenario.
 *
 * ### When to call Confirm Or Decline Booking instead
 *
 * Confirm Booking doesn't check whether a slot or schedule is still available.
 * For these checks, call [Confirm or Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking) instead.
 *
 * ### Original status validation
 *
 * You can only confirm bookings with a status of `PENDING`, `CREATED`, or
 * `WAITING_LIST`.
 *
 * ### Double bookings
 *
 * Confirm Booking doesn't check whether a slot or schedule is still available.
 * You can specify
 *
 * ```json
 * {
 * "flowControlSettings": {
 * "checkAvailabilityValidation": true
 * },
 * "doubleBooked": true
 * }
 * ```
 * to forcefully set the booking's `doubleBooked` flag to `true`, regardless of
 * a potential double booking conflict. You must call with `Manage Bookings`
 * permissions to do so. For the default flow control settings
 * `{"checkAvailabilityValidation": false}`, the specified `doubleBooked` value
 * is ignored.
 *
 * ### Payment status
 *
 * Also updates the booking's `paymentStatus`, if you specify a new payment
 * status.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer. To send
 * the message, you must also specify `participantNotification.notifyParticipants`
 * as `true`.
 */
export function bookingsConfirmBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __bookingsConfirmBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.ConfirmBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings/{bookingId}/confirm',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bookingsConfirmBooking;
}

/**
 * Sets a form submission ID for a booking.
 *
 *
 * Use this method to associate a [Wix Forms submission](https://dev.wix.com/docs/api-reference/crm/forms/form-submissions/introduction) with a booking, or to replace an existing form submission with a new one.
 *
 * Learn more about [how Bookings integrates with Wix Forms](https://dev.wix.com/docs/api-reference/business-solutions/bookings/wix-forms-integration).
 */
export function setBookingSubmissionId(
  payload: object
): RequestOptionsFactory<any> {
  function __setBookingSubmissionId({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.Bookings.SetBookingSubmissionId',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings/{bookingId}/set-booking-submission-id',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __setBookingSubmissionId;
}

/**
 * Updates the extended fields for a booking.
 *
 *
 * If you specify an extended field `namespace` that doesn't exist yet, it's
 * created.
 *
 * Learn more about [extended fields](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/about-backend-extensions#schema-plugin-extensions).
 */
export function updateExtendedFields(
  payload: object
): RequestOptionsFactory<any> {
  function __updateExtendedFields({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.Bookings.UpdateExtendedFields',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings/{id}/update_extended_fields',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updateExtendedFields;
}

/**
 * Updates the booking status to `DECLINED` without checking whether the relevant slot or schedule is still available.
 *
 *
 * ### eCommerce checkout restriction
 *
 * Call this method only when using a custom checkout page.
 * Don't call it when using a [Wix eCommerce checkout](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction).
 * In such cases, Wix Bookings automatically updates the booking status based on the `paymentStatus` of the corresponding [Wix eCommerce order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction).
 *
 * ### When to call Decline Booking
 *
 * When using a custom checkout, call this method to decline bookings that don't have a double booking conflict.
 * The alternative [Confirm or Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking) method doesn't support this scenario.
 *
 * ### When to call Confirm Or Decline Booking instead
 *
 * Decline Booking doesn't check whether a slot or schedule is still available.
 * For these checks you can call [Confirm or Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking).
 *
 * ### Original status validation
 *
 * You can only decline bookings with a `status` of `PENDING`, `CREATED`, or
 * `WAITING_LIST`.
 *
 * ### Payment status
 *
 * Also updates the booking's `paymentStatus`, if you specify a new payment
 * status.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer. To send
 * the message, you must also specify `participantNotification.notifyParticipants`
 * as `true`.
 */
export function bookingsDeclineBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __bookingsDeclineBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.DeclineBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings/{bookingId}/decline',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bookingsDeclineBooking;
}

/**
 * Updates the booking status to `CANCELED`.
 *
 *
 * ### Appointments
 *
 * For appointments, the corresponding event is removed from the Bookings
 * calendar.
 *
 * ### Class and course bookings
 *
 * For class or course bookings, the relevant participants are removed
 * from the class session or the course. However, the class session or course
 * remain on the business calendar.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer. To send
 * the message, you must also specify `participantNotification.notifyParticipants`
 * as `true`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences when you specify special
 * `flowControlSettings`:
 *
 * - `{"ignoreCancellationPolicy": true}`: The call succeeds even if the
 * service's `cancellationPolicy` doesn't allow it.
 * - `{"withRefund": true}`: The customer is refunded even if the service's
 * `refundPolicy` doesn't allow it.
 * - `{"waiveCancellationFee": true}`: The customer doesn't have to pay
 * the cancellation fee, even if the service's `cancellationPolicy` requires it.
 *
 * When using special `flowControlSettings`, ensure you have sufficient
 * permissions. If you encounter failed calls due to insufficient permissions,
 * consider the following options:
 *
 * - **App developers** can use a higher
 * [permission](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions),
 * such as `MANAGE BOOKINGS - ALL PERMISSIONS`.
 * - **Site developers** can utilize
 * [elevation](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/authorization/elevation).
 *
 * Granting additional permissions and using elevation permits method calls that
 * would typically fail due to authorization checks. Therefore, you should use
 * them intentionally and securely.
 */
export function bookingsCancelBooking(
  payload: object
): RequestOptionsFactory<any> {
  function __bookingsCancelBooking({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CancelBooking',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings/{bookingId}/cancel',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bookingsCancelBooking;
}

/**
 * Updates the number of participants for a class or course booking and changes
 * the `totalNumberOfParticipants` for the relevant sessions.
 *
 *
 * ### Appointment limitation
 *
 * You can't update the number of participants for appointment bookings.
 *
 * ### Participant information
 *
 * You must specify either `participantsChoices` or `totalParticipants`.
 * The call fails if the specified `participantsChoices` aren't among the
 * supported [service options and variants](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction).
 */
export function bookingsUpdateNumberOfParticipants(
  payload: object
): RequestOptionsFactory<any> {
  function __bookingsUpdateNumberOfParticipants({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.Bookings.UpdateNumberOfParticipants',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings/{bookingId}/update_number_of_participants',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bookingsUpdateNumberOfParticipants;
}

/**
 * Checks whether you can [reschedule](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/reschedule-booking) or [cancel](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/cancel-booking) a list of bookings without using [force resolution](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings/bookings-writer-v2/sample-flows#force-resolution).
 *
 *
 * Call this method to determine which standard actions are available before attempting to modify bookings. If standard actions aren't available, you may need to use force resolution to override business rules and availability validation.
 */
export function bulkCalculateAllowedActions(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkCalculateAllowedActions({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.Bookings.BulkCalculateAllowedActions',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bulk/bookings/calculate_allowed_actions',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkCalculateAllowedActions;
}

/**
 * Updates the booking status to `PENDING`.
 *
 *
 * ### Service requirement
 *
 * By default, this method only works for [services](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/introduction) with `service.onlineBooking.requireManualApproval` set to `true`.
 * If you attempt to mark a booking as pending for a service that doesn't require approval, the call fails unless you use the `skipPendingApprovalServiceValidation` admin overwrite.
 *
 * ### Status requirements
 *
 * - __Original status__: Booking must have `CREATED` status.
 * - __Target status__: Booking moves to `PENDING`.
 *
 * ### Checkout restrictions
 *
 * Only call this method if the customer paid via a custom checkout. For [Wix eCommerce checkouts](https://dev.wix.com/docs/rest/business-solutions/e-commerce/purchase-flow/checkout/introduction), Wix Bookings automatically manages the bookings' statuses based on payment processing.
 *
 * When using custom checkouts, you can also update the booking's `paymentStatus` by specifying a new payment status.
 *
 * ### Business workflow
 *
 * After marking a booking as `PENDING`, the business must manually approve or reject it. You can call these methods:
 * - [Confirm Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-booking).
 * - [Decline Booking](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/decline-booking).
 *
 * ### Resource availability and scheduling
 *
 * Marking a booking as `PENDING` immediately affects resource availability:
 *
 * - **Calendar impact**: The booking appears on the business calendar.
 * - **Availability**: The time slot becomes unavailable for other bookings, even while pending approval.
 * - **Resource assignment**: Available [resources](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resources-v2/introduction) are automatically assigned if none were explicitly selected during booking creation.
 *
 * ### Double bookings
 *
 * By default, the method doesn't check for availability conflicts. To detect and handle double bookings, use the `checkAvailabilityValidation: true` admin overwrite.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer.
 * To send the message, you must also specify `participantNotification.notifyParticipants` as `true`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences when you specify special
 * `flowControlSettings`:
 *
 * - `{"checkAvailabilityValidation": true}`: Checks for double booking conflicts before updating the status.
 * When conflicts exist, the booking is still marked as `PENDING` and `doubleBooked` is set to `true` for the business to resolve manually.
 * - `{"skipPendingApprovalServiceValidation": true}`: Allows marking any booking as pending, even if the service doesn't require manual approval.
 *
 * When using special `flowControlSettings`, ensure you have sufficient permissions.
 * If you encounter failed calls due to insufficient permissions, consider the following options:
 *
 * - __App developers__ can use a higher
 * [permission](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions), such as `MANAGE BOOKINGS - ALL PERMISSIONS`.
 * - __Site developers__ can utilize
 * [elevation](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/authorization/elevation).
 *
 * Granting additional permissions and using elevation permits method calls that would typically fail due to authorization checks.
 * Therefore, you should use them intentionally and securely.
 */
export function markBookingAsPending(
  payload: object
): RequestOptionsFactory<any> {
  function __markBookingAsPending({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v2.booking',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.bookings.v2.Bookings.MarkBookingAsPending',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsBookingsV2BookingsUrl({
        protoPath: '/v2/bookings/{bookingId}/mark_booking_as_pending',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'booking.createdDate' },
              { path: 'booking.startDate' },
              { path: 'booking.endDate' },
              { path: 'booking.updatedDate' },
              { path: 'booking.canceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
              { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __markBookingAsPending;
}
